"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var recharts_1 = require("recharts");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var changeCase = __importStar(require("change-case"));
var TableLogic_1 = require("../../base/Table/TableLogic");
var TickHandler_1 = require("./TickHandler");
var formatter = ksys_app_template_1.utils.formatter.formatter;
var isNullOrEmpty = ksys_app_template_1.utils.typeChecks.isNullOrEmpty;
var CustomSeriesLabel_1 = __importDefault(require("./styledComponents/CustomSeriesLabel"));
var LastSeriesLabel_1 = __importDefault(require("./styledComponents/LastSeriesLabel"));
var CustomizedShape_1 = require("../ScatterChart/styledComponents/CustomizedShape");
exports.KSYS_CHART_ANIMATION_KEY = 'ksysChartIsAnimationActive';
var SIZE = 32;
function orchestrateElements(defaultElements) {
    var configurations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        configurations[_i - 1] = arguments[_i];
    }
    var response = [];
    if (defaultElements) {
        for (var _a = 0, defaultElements_1 = defaultElements; _a < defaultElements_1.length; _a++) {
            var defaultElement = defaultElements_1[_a];
            var element = Object.assign({}, defaultElement);
            var override = void 0;
            for (var _b = 0, _c = (configurations || []); _b < _c.length; _b++) {
                var configuration = _c[_b];
                override = overrideChartElement(element, configuration, override);
            }
            if (override && !override.exclude) {
                response.push(element);
            }
        }
    }
    return response;
}
exports.orchestrateElements = orchestrateElements;
function overrideChartElement(element, chart, previousOverride) {
    var response = {
        element: element,
        exclude: previousOverride && previousOverride.exclude,
    };
    var elementOverridesKey = changeCase.camelCase(element.type);
    if (chart && chart.elementOverrides) {
        var override = chart.elementOverrides[elementOverridesKey];
        if (override) {
            response.exclude = !!override.hide;
            if (!response.exclude) {
                var hide = override.hide, otherProps = __rest(override, ["hide"]);
                element.props = ksys_app_template_1.utils.object.deepMergeObjects(element.props || {}, otherProps);
            }
        }
    }
    return response;
}
function orchestrateElement(element) {
    var _a;
    var overrides = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        overrides[_i - 1] = arguments[_i];
    }
    var response = Object.assign({}, element);
    response.props = (_a = ksys_app_template_1.utils.object).deepMergeObjects.apply(_a, __spreadArrays([element.props || {}], overrides));
    return response;
}
exports.orchestrateElement = orchestrateElement;
function getResponsiveContainerProps() {
    var _a;
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    var defaultResponsiveContainerProps = {};
    var configurationsToMerge = (configurations || []).map(function (configuration) { return configuration.responsiveContainerProps; });
    return (_a = ksys_app_template_1.utils.object).deepMergeObjects.apply(_a, __spreadArrays([defaultResponsiveContainerProps], configurationsToMerge));
}
exports.getResponsiveContainerProps = getResponsiveContainerProps;
function getComposedChartProps() {
    var _a;
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    if (configurations && configurations.length > 0) {
        var props = configurations[configurations.length - 1];
        var composedChartProps = props.composedChartProps;
        var data = props.data;
        if (!data) {
            data = composedChartProps && composedChartProps.data;
        }
        var defaultComposedChartProps = {};
        var configurationsToMerge = (configurations || []).map(function (configuration) { return configuration.composedChartProps; });
        return (_a = ksys_app_template_1.utils.object).deepMergeObjects.apply(_a, __spreadArrays([defaultComposedChartProps], configurationsToMerge, [{ data: data }]));
    }
    return {};
}
exports.getComposedChartProps = getComposedChartProps;
function getCoreChartElements() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    var defaultCoreChartElements = [
        {
            type: 'CartesianGrid',
        },
        {
            type: 'XAxis',
        },
        {
            type: 'YAxis',
        },
        {
            type: 'ZAxis',
        },
        {
            type: 'Tooltip',
        },
        {
            type: 'Legend',
        },
    ];
    return orchestrateElements.apply(void 0, __spreadArrays([defaultCoreChartElements], (configurations || [])));
}
exports.getCoreChartElements = getCoreChartElements;
function getSeriesElement(defaultSeriesElement) {
    var configurations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        configurations[_i - 1] = arguments[_i];
    }
    var chartElements = [];
    if (configurations && configurations.length > 0) {
        var props = configurations[configurations.length - 1];
        var _a = props.seriesProps, fromPropsCollection = _a === void 0 ? [] : _a;
        var seriesColors = getSeriesColors.apply(void 0, configurations);
        var commonConfigruations = configurations.map(function (configuration) { return configuration.commonSeriesProps; });
        for (var seriesIndex = 0; seriesIndex < fromPropsCollection.length; seriesIndex++) {
            var fromProps = fromPropsCollection[seriesIndex];
            if (fromProps.hasData) {
                var seriesElement = orchestrateElement.apply(void 0, __spreadArrays([defaultSeriesElement], commonConfigruations, [fromProps]));
                var props_1 = seriesElement.props;
                if (props_1 && !props_1.fill && seriesColors && seriesColors.length > 0) {
                    var color = seriesColors[seriesIndex % seriesColors.length];
                    props_1.fill = color;
                    props_1.colors = seriesColors;
                }
                chartElements.push(seriesElement);
            }
        }
    }
    return chartElements;
}
exports.getSeriesElement = getSeriesElement;
function getSeriesColors() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var colors = configuration.colors;
        if (colors) {
            return colors;
        }
    }
    return [];
}
exports.getSeriesColors = getSeriesColors;
function getAdditionalChartElements() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var additionalElements = configuration.additionalElements;
        if (additionalElements) {
            return additionalElements;
        }
    }
    return [];
}
exports.getAdditionalChartElements = getAdditionalChartElements;
function getChartElements(defaultSeriesElement) {
    var configurations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        configurations[_i - 1] = arguments[_i];
    }
    return __spreadArrays((getCoreChartElements.apply(void 0, configurations) || []), appendReferenceLines(configurations), getSeriesElement.apply(void 0, __spreadArrays([defaultSeriesElement], configurations)), getAdditionalChartElements.apply(void 0, configurations));
}
exports.getChartElements = getChartElements;
function getMeanTickPivotPoint(composedChartData, dataKey) {
    var total = composedChartData.reduce(function (total, current) {
        return total + Number(current[dataKey.toString()]);
    }, 0);
    return Math.round(total / composedChartData.length);
}
exports.getMeanTickPivotPoint = getMeanTickPivotPoint;
function appendReferenceLines(configurations) {
    var referenceLines = [];
    for (var _i = 0, _a = __spreadArrays(configurations).reverse(); _i < _a.length; _i++) {
        var configuration = _a[_i];
        if (configuration) {
            var xPivotReferenceLine = configuration.xPivotReferenceLine, yPivotReferenceLine = configuration.yPivotReferenceLine, elementOverrides = configuration.elementOverrides;
            if (elementOverrides) {
                if (elementOverrides.xAxis && xPivotReferenceLine) {
                    var pivot = elementOverrides.xAxis.tickPivotPoint;
                    if (pivot !== undefined) {
                        referenceLines.push({
                            props: __assign({ stroke: 'black', x: pivot }, xPivotReferenceLine),
                            type: 'ReferenceLine',
                        });
                    }
                }
                if (elementOverrides.yAxis && yPivotReferenceLine) {
                    var pivot = elementOverrides.yAxis.tickPivotPoint;
                    if (pivot !== undefined) {
                        referenceLines.push({
                            props: __assign({ stroke: 'black', y: pivot }, yPivotReferenceLine),
                            type: 'ReferenceLine',
                        });
                    }
                }
            }
        }
    }
    return referenceLines;
}
exports.appendReferenceLines = appendReferenceLines;
function getChartDisclaimersProps() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var disclaimersProps = configuration.disclaimersProps;
        if (disclaimersProps) {
            return disclaimersProps;
        }
    }
    return;
}
exports.getChartDisclaimersProps = getChartDisclaimersProps;
function getChartBaseProps(defaultSeriesElement) {
    var configurations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        configurations[_i - 1] = arguments[_i];
    }
    var cleanConfigurations = configurations.filter(function (configuration) { return !!configuration; }).map(function (configuration) {
        if (configuration && configuration.elementOverrides &&
            configuration.elementOverrides.xAxis && configuration.elementOverrides.yAxis &&
            configuration.composedChartProps && configuration.composedChartProps.data) {
            var xAxis = configuration.elementOverrides.xAxis;
            var yAxis = configuration.elementOverrides.yAxis;
            var updatedConfiguration = configuration;
            if (yAxis.useMeanTickPivotPoint && !yAxis.tickPivotPoint && yAxis.dataKey) {
                updatedConfiguration = __assign(__assign({}, configuration), { elementOverrides: __assign(__assign({}, configuration.elementOverrides), { yAxis: __assign({ tickPivotPoint: getMeanTickPivotPoint(configuration.composedChartProps.data, yAxis.dataKey) }, yAxis) }) });
            }
            if (xAxis.useMeanTickPivotPoint && !xAxis.tickPivotPoint && xAxis.dataKey) {
                updatedConfiguration = __assign(__assign({}, configuration), { elementOverrides: __assign(__assign({}, updatedConfiguration.elementOverrides), { xAxis: __assign({ tickPivotPoint: getMeanTickPivotPoint(configuration.composedChartProps.data, xAxis.dataKey) }, xAxis) }) });
            }
            return updatedConfiguration;
        }
        return configuration;
    });
    // various functions do the reverse() before using the config so do it once here and pass it where necessary
    var reverseCleanConfigurations = __spreadArrays(cleanConfigurations).reverse();
    seriesHasData.apply(void 0, cleanConfigurations);
    var response = {
        cleanConfigurations: cleanConfigurations,
        // Passed as prop by app
        appKey: reverseCleanConfigurations[0].appKey,
        // Passed as prop by app
        queryStore: reverseCleanConfigurations[0].queryStore,
        responsiveContainerProps: getResponsiveContainerProps.apply(void 0, cleanConfigurations),
        composedChartProps: getComposedChartProps.apply(void 0, cleanConfigurations),
        elements: getChartElements.apply(void 0, __spreadArrays([defaultSeriesElement], cleanConfigurations)),
        disclaimersProps: getChartDisclaimersProps.apply(void 0, cleanConfigurations),
        breakpoints: getChartBreakpoints.apply(void 0, __spreadArrays([defaultSeriesElement], cleanConfigurations)),
        rebaseOptions: getRebaseOptions.apply(void 0, cleanConfigurations),
        dateOptions: getDateOptions.apply(void 0, cleanConfigurations),
        selectedChartPeriod: getSelectedChartPeriod.apply(void 0, cleanConfigurations),
        chartBaseComponent: (cleanConfigurations && cleanConfigurations.length > 0 && cleanConfigurations[cleanConfigurations.length - 1].chartBaseComponent) || 'ComposedChart',
    };
    return response;
}
exports.getChartBaseProps = getChartBaseProps;
function getHighLowChartProps(props) {
    var returnProps = props;
    var rawData = props.composedChartProps && props.composedChartProps.data || [];
    if (rawData.length === 0) {
        rawData = props.data;
    }
    if (rawData && props.highLowBubbleChartProps) {
        var _a = props.highLowBubbleChartProps, xDatakey_1 = _a.xDatakey, yDatakey_1 = _a.yDatakey, zDatakey_1 = _a.zDatakey, xLabel = _a.xLabel, yLabel = _a.yLabel, zLabel = _a.zLabel, highLowKey = _a.highLowKey, highLowValue = _a.highLowValue, lowColors_1 = _a.lowColors, highColors_1 = _a.highColors, midBubbleBorderColor_1 = _a.midBubbleBorderColor, midBubbleBorderWeight_1 = _a.midBubbleBorderWeight, midBubbleColor_1 = _a.midBubbleColor, minDotSize_1 = _a.minDotSize, maxDotSize = _a.maxDotSize, showDataInLegend_1 = _a.showDataInLegend, legendDataFormatter_1 = _a.legendDataFormatter, sortOptions = _a.sortOptions;
        var bubbleSortOrder = (sortOptions && sortOptions.sortOrder) || 'descending';
        var sortDataKey_1 = (sortOptions && sortOptions.dataKey) || yDatakey_1;
        var highLowSortKey_1 = highLowKey || yDatakey_1;
        var key_1 = '';
        var value_1 = '';
        var highlightFillColor_1 = '';
        if (props.highlightDataPointProps && props.highlightDataPointProps.key) {
            key_1 = props.highlightDataPointProps.key;
            value_1 = props.highlightDataPointProps.value;
        }
        if (props.highlightDataPointProps && props.highlightDataPointProps.fillColor) {
            highlightFillColor_1 = props.highlightDataPointProps.fillColor;
        }
        var highlightPoint_1 = rawData.find(function (datapoint) { return datapoint[key_1] === value_1; });
        var data = rawData.sort(function (a, b) { return (b[highLowSortKey_1] > a[highLowSortKey_1]) ? 1 : -1; });
        if (highlightPoint_1 === undefined && props.highlightDataPointProps) {
            highlightPoint_1 = data[data.length - 1];
        }
        var highValues_1 = [];
        var lowValues_1 = [];
        var seriesData = [];
        var max = 0;
        var min = 0;
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            var value_2 = item[zDatakey_1];
            // Check if value is in the high values
            if (i < highLowValue) {
                highValues_1.push(item);
            }
            // Check if value is in the low values
            else if (i >= data.length - highLowValue) {
                lowValues_1.push(item);
            }
            // Start Loading up the Series Data, Mid Values will populate series data first to be rendered first (below) other scatter points
            else {
                seriesData.push(item);
            }
            if (i === 0) {
                min = value_2;
                max = value_2;
            }
            else {
                min = Math.min(min, value_2);
                max = Math.max(max, value_2);
            }
        }
        seriesData.push.apply(seriesData, __spreadArrays(lowValues_1, highValues_1));
        seriesData = bubbleSortOrder === 'descending' ? seriesData.sort(function (a, b) { return (b[sortDataKey_1] > a[sortDataKey_1]) ? 1 : -1; }) : seriesData.sort(function (a, b) { return (a[sortDataKey_1] > b[sortDataKey_1]) ? 1 : -1; });
        var sizeRange = maxDotSize - minDotSize_1;
        var valueRange = max - min;
        var sizeValueRatio_1 = sizeRange / valueRange;
        var seriesProps = seriesData.map(function (datapoint) {
            var size = (datapoint[zDatakey_1] * sizeValueRatio_1) + minDotSize_1;
            if (lowValues_1.includes(datapoint)) {
                var index = lowValues_1.findIndex(function (item) {
                    return item === datapoint;
                });
                return {
                    data: [datapoint],
                    name: datapoint.label,
                    fill: lowColors_1[index],
                    shape: React.createElement(CustomizedShape_1.CustomizedShape, { radius: size, borderColor: '#cccccc', borderWeight: 1 }),
                };
            }
            if (highValues_1.includes(datapoint)) {
                var index = highValues_1.findIndex(function (item) {
                    return item === datapoint;
                });
                return {
                    data: [datapoint],
                    name: datapoint.label,
                    fill: highColors_1[index],
                    shape: React.createElement(CustomizedShape_1.CustomizedShape, { radius: size, borderColor: '#cccccc', borderWeight: 1 }),
                };
            }
            return {
                data: [datapoint],
                name: datapoint.label,
                fill: midBubbleColor_1 || '#ffffff',
                shape: React.createElement(CustomizedShape_1.CustomizedShape, { radius: size, borderColor: midBubbleBorderColor_1 || '#cccccc', borderWeight: midBubbleBorderWeight_1 || 1 }),
            };
        });
        var minX = data.reduce(function (acc, datapoint, index) {
            if (index === 0) {
                return datapoint[xDatakey_1];
            }
            return Math.min(datapoint[xDatakey_1], acc);
        }, 0);
        var maxX = data.reduce(function (acc, datapoint, index) {
            if (index === 0) {
                return datapoint[xDatakey_1];
            }
            return Math.max(datapoint[xDatakey_1], acc);
        }, 0);
        var minY = data.reduce(function (acc, datapoint, index) {
            if (index === 0) {
                return datapoint[yDatakey_1];
            }
            return Math.min(datapoint[yDatakey_1], acc);
        }, 0);
        var maxY = data.reduce(function (acc, datapoint, index) {
            if (index === 0) {
                return datapoint[yDatakey_1];
            }
            return Math.max(datapoint[yDatakey_1], acc);
        }, 0);
        var minXDomain = Math.floor(minX);
        var maxXDomain = Math.ceil(maxX);
        var minYDomain = Math.floor(minY);
        var maxYDomain = Math.ceil(maxY);
        returnProps = __assign(__assign({}, returnProps), { seriesProps: seriesProps, chartBaseComponent: 'ScatterChart', elementOverrides: __assign(__assign({}, props.elementOverrides), { xAxis: __assign(__assign({ domain: [minXDomain, maxXDomain] }, (props.elementOverrides && props.elementOverrides.xAxis)), { dataKey: xDatakey_1, type: 'number', name: xLabel, unit: '' }), yAxis: __assign(__assign({ domain: [minYDomain, maxYDomain] }, (props.elementOverrides && props.elementOverrides.yAxis)), { dataKey: yDatakey_1, type: 'number', name: yLabel, unit: '' }), zAxis: __assign(__assign({}, (props.elementOverrides && props.elementOverrides.zAxis)), { dataKey: zDatakey_1, type: 'number', name: zLabel, unit: '' }), legend: __assign(__assign({}, (props.elementOverrides && props.elementOverrides.legend)), { payload: [] }) }) });
        if (returnProps && returnProps.elementOverrides && returnProps.elementOverrides.legend && returnProps.elementOverrides.legend.payload) {
            var payload_1 = returnProps.elementOverrides.legend.payload;
            highValues_1.forEach(function (datapoint, index) {
                var label = datapoint.label;
                var color = highColors_1[index];
                if (showDataInLegend_1) {
                    var dataValue = datapoint[yDatakey_1];
                    if (legendDataFormatter_1) {
                        dataValue = formatter(legendDataFormatter_1, dataValue);
                    }
                    label = datapoint.label + ": " + dataValue;
                }
                if (highlightPoint_1 === datapoint) {
                    color = highlightFillColor_1;
                }
                payload_1.push({
                    color: color,
                    value: label,
                    id: datapoint.label + "_" + index,
                    type: 'circle',
                });
            });
            lowValues_1.forEach(function (datapoint, index) {
                var label = datapoint.label;
                var color = lowColors_1[index];
                if (showDataInLegend_1) {
                    var dataValue = datapoint[yDatakey_1];
                    if (legendDataFormatter_1) {
                        dataValue = formatter(legendDataFormatter_1, dataValue);
                    }
                    label = datapoint.label + ": " + dataValue;
                }
                if (highlightPoint_1 === datapoint) {
                    color = highlightFillColor_1;
                }
                payload_1.push({
                    color: color,
                    value: label,
                    id: datapoint.label + "_" + index,
                    type: 'circle',
                });
            });
        }
    }
    return returnProps;
}
exports.getHighLowChartProps = getHighLowChartProps;
function highlightDataProps(props) {
    var returnProps = props;
    var seriesProps = props.seriesProps || [];
    if (seriesProps.length > 0 && props.highlightDataPointProps) {
        var _a = props.highlightDataPointProps, key_2 = _a.key, value_3 = _a.value, fillColor = _a.fillColor, size = _a.size, borderColor = _a.borderColor, borderWeight = _a.borderWeight;
        var index = seriesProps.length - 1;
        if (key_2) {
            // Gets the index of the highlighted data point for styles to be applied on
            index = seriesProps.findIndex(function (datapoint) { return datapoint.data[0][key_2] === value_3; });
        }
        if (index !== -1) {
            seriesProps[index] = __assign(__assign({}, seriesProps[index]), { name: seriesProps[index].label, fill: fillColor, shape: (React.createElement(CustomizedShape_1.CustomizedShape, { radius: size, borderColor: borderColor, borderWeight: borderWeight || 1 })) });
        }
    }
    return returnProps;
}
exports.highlightDataProps = highlightDataProps;
function getChartSyncTicks(chartProps, elements, composedChartProps) {
    // Used to allow the x and y axis to have the same ticks
    if (chartProps.chartBaseComponent === 'ScatterChart' && chartProps.syncXYTicks) {
        var axisElements = elements.reduce(function (acc, element) {
            if (element.type === 'XAxis' || element.type === 'YAxis') {
                // Get the ticks for the series
                applyTickPivotPoint(element, elements, composedChartProps);
                acc.set(element.type, element);
            }
            return acc;
        }, new Map());
        var tickFormatter = void 0;
        var tickPivotPoint = void 0;
        var centerTickPivotPoint = void 0;
        var combinedTicks = [];
        var xAxisElement = axisElements.get('XAxis');
        if (xAxisElement && xAxisElement.props && xAxisElement.props.ticks) {
            var _a = xAxisElement.props, xTickFormatter = _a.tickFormatter, xTickPivotPoint = _a.tickPivotPoint, xCenterTickPivotPoint = _a.centerTickPivotPoint, ticks = _a.ticks;
            tickFormatter = xTickFormatter;
            tickPivotPoint = xTickPivotPoint;
            centerTickPivotPoint = xCenterTickPivotPoint;
            if (ticks) {
                combinedTicks.push.apply(combinedTicks, ticks);
            }
        }
        var yAxisElement = axisElements.get('YAxis');
        if (yAxisElement && yAxisElement.props && yAxisElement.props.ticks) {
            var _b = yAxisElement.props, yTickFormatter = _b.tickFormatter, yTickPivotPoint = _b.tickPivotPoint, yCenterTickPivotPoint = _b.centerTickPivotPoint, ticks = _b.ticks;
            // If not set by xAxis, then set the following
            if (!tickFormatter) {
                tickFormatter = yTickFormatter;
            }
            if (!tickPivotPoint) {
                tickPivotPoint = yTickPivotPoint;
            }
            if (!centerTickPivotPoint) {
                centerTickPivotPoint = yCenterTickPivotPoint;
            }
            // ********************************************
            if (ticks) {
                combinedTicks.push.apply(combinedTicks, ticks);
            }
        }
        var precision = getTickPrecision(tickFormatter);
        var combinedTickCount = combinedTicks.length;
        var min = Math.min.apply(Math, combinedTicks);
        var max = Math.max.apply(Math, combinedTicks);
        var tickHandler = new TickHandler_1.TickHandler({ precision: precision, count: combinedTickCount });
        // Work out the new combined ticks around the point
        var ticksAroundPoint = tickHandler.getTicksAroundPoint(tickPivotPoint === undefined ? 1 : tickPivotPoint, max, min, centerTickPivotPoint);
        return {
            ticks: ticksAroundPoint,
            tickCount: combinedTickCount,
        };
    }
}
exports.getChartSyncTicks = getChartSyncTicks;
var seriesHasData = function () {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var seriesProps = configuration.seriesProps;
        var data = configuration.data;
        if (seriesProps) {
            var _loop_1 = function (seriesProp) {
                var dataKey = seriesProp.dataKey;
                var hasData = false;
                var length_1 = 0;
                var count = 0;
                // Scatter charts dont have a data key on the series but on the axis
                if (dataKey) {
                    if (data) {
                        length_1 = data.length;
                        count = data.filter(function (dataPoint) { return dataPoint.hasOwnProperty(dataKey) && dataPoint[dataKey] !== undefined && dataPoint[dataKey] !== null; }).length;
                        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                            var dataPoint = data_1[_i];
                            if (dataPoint.hasOwnProperty(dataKey) && dataPoint[dataKey]) {
                                hasData = true;
                                break;
                            }
                        }
                    }
                }
                else {
                    hasData = true;
                }
                Object.assign(seriesProp, { hasData: hasData, count: count, length: length_1 });
            };
            for (var _c = 0, seriesProps_1 = seriesProps; _c < seriesProps_1.length; _c++) {
                var seriesProp = seriesProps_1[_c];
                _loop_1(seriesProp);
            }
        }
    }
};
function getRebaseOptions() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    var options;
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var rebaseOptions = configuration.rebaseOptions, _c = configuration.seriesProps, seriesProps = _c === void 0 ? [] : _c;
        if (rebaseOptions) {
            var seriesToRemove = getRebaseSeriesToRemove(seriesProps);
            for (var _d = 0, seriesToRemove_1 = seriesToRemove; _d < seriesToRemove_1.length; _d++) {
                var key = seriesToRemove_1[_d];
                removeRebaseOptions(key, rebaseOptions);
            }
            options = rebaseOptions;
        }
    }
    return options;
}
exports.getRebaseOptions = getRebaseOptions;
var getRebaseSeriesToRemove = function (seriesProps) {
    var series = [];
    if (seriesProps) {
        seriesProps.forEach(function (serie) {
            if (!serie.hasData) {
                series.push(serie.dataKey);
            }
        });
    }
    return series;
};
var removeRebaseOptions = function (key, options) {
    var series = options.series;
    if (series) {
        var idx = series.findIndex(function (elem) { return elem.key === key; });
        if (idx !== -1) {
            series.splice(idx, 1);
        }
    }
};
function getDateOptions() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var dateOptions = configuration.dateOptions;
        if (dateOptions) {
            return dateOptions;
        }
    }
}
exports.getDateOptions = getDateOptions;
function getSelectedChartPeriod() {
    var configurations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configurations[_i] = arguments[_i];
    }
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var selectedChartPeriod = configuration.selectedChartPeriod;
        if (selectedChartPeriod) {
            return selectedChartPeriod;
        }
    }
}
exports.getSelectedChartPeriod = getSelectedChartPeriod;
function getChartBreakpoints(defaultSeriesElement) {
    var configurations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        configurations[_i - 1] = arguments[_i];
    }
    var _loop_2 = function (configuration) {
        var breakpoints = configuration.breakpoints;
        if (breakpoints) {
            var props_2 = configurations[configurations.length - 1];
            return { value: breakpoints.map(function (breakpoint) {
                    var modifier = breakpoint.modifier, size = breakpoint.size, propsFormBreakpoint = breakpoint.props;
                    var breakpointProps = ksys_app_template_1.utils.object.deepMergeObjects(props_2, propsFormBreakpoint);
                    var cleanConfigurations = __spreadArrays(configurations, [breakpointProps]).map(function (configuration) {
                        var breakpoints = configuration.breakpoints, otherProps = __rest(configuration, ["breakpoints"]);
                        return otherProps;
                    });
                    return {
                        size: size,
                        modifier: modifier,
                        props: getChartBaseProps.apply(void 0, __spreadArrays([defaultSeriesElement], cleanConfigurations)),
                    };
                }) };
        }
    };
    for (var _a = 0, _b = __spreadArrays(configurations).reverse(); _a < _b.length; _a++) {
        var configuration = _b[_a];
        var state_1 = _loop_2(configuration);
        if (typeof state_1 === "object")
            return state_1.value;
    }
}
exports.getChartBreakpoints = getChartBreakpoints;
function applyFormatters(element, translationContext) {
    // Convert the tickFormatter from IFormatter to a function
    if (element.type === 'Brush' ||
        element.type === 'CartesianAxis' ||
        element.type === 'PolarAngleAxis' ||
        element.type === 'PolarRadiusAxis' ||
        element.type === 'XAxis' ||
        element.type === 'YAxis') {
        if (element.props) {
            var formatterConfiguration_1 = element.props.tickFormatter;
            if (formatterConfiguration_1 && typeof formatterConfiguration_1 === 'object') {
                element.props = Object.assign({}, element.props, {
                    tickFormatter: function (value) {
                        if (!formatterConfiguration_1.locale) {
                            formatterConfiguration_1.locale = translationContext && translationContext.culture;
                        }
                        if (!formatterConfiguration_1.options) {
                            formatterConfiguration_1.options = {};
                        }
                        // Translate the Threshold Text
                        if (formatterConfiguration_1.options.numberThresholds) {
                            formatterConfiguration_1.options.numberThresholds.forEach(function (numThreshold) {
                                numThreshold.text = translationContext.translate(numThreshold.text);
                            });
                        }
                        return formatter(formatterConfiguration_1, value);
                    },
                });
            }
        }
    }
    if (element.type === 'Tooltip' ||
        element.type === 'Pie' ||
        element.type === 'RadialBar') {
        if (element.props) {
            var formatterConfiguration_2 = element.props.formatter;
            if (formatterConfiguration_2 && typeof formatterConfiguration_2 === 'object') {
                element.props = Object.assign({}, element.props, {
                    formatter: function (value) {
                        if (!formatterConfiguration_2.locale) {
                            formatterConfiguration_2.locale = translationContext && translationContext.culture;
                        }
                        if (!formatterConfiguration_2.options) {
                            formatterConfiguration_2.options = {};
                        }
                        return formatter(formatterConfiguration_2, value);
                    },
                });
            }
            var labelFormatterConfiguration_1 = element.props.labelFormatter;
            if (labelFormatterConfiguration_1 && typeof labelFormatterConfiguration_1 === 'object') {
                element.props = Object.assign({}, element.props, {
                    labelFormatter: function (value) {
                        if (!labelFormatterConfiguration_1.locale) {
                            labelFormatterConfiguration_1.locale = translationContext && translationContext.culture;
                        }
                        if (!labelFormatterConfiguration_1.options) {
                            labelFormatterConfiguration_1.options = {};
                        }
                        return formatter(labelFormatterConfiguration_1, value);
                    },
                });
            }
        }
    }
}
exports.applyFormatters = applyFormatters;
function getDynamicReferenceLines(elements, composedChartProps, configurations) {
    var returnElements = [];
    var workingElements = __spreadArrays(elements);
    var xAxis = workingElements.find(function (ele) { return ele.type === 'XAxis'; });
    var yAxis = workingElements.find(function (ele) { return ele.type === 'YAxis'; });
    var xAxisTicks = [];
    var yAxisTicks = [];
    if (xAxis) {
        xAxisTicks = getTicks(xAxis, workingElements, composedChartProps) || [];
    }
    if (yAxis) {
        yAxisTicks = getTicks(yAxis, workingElements, composedChartProps) || [];
    }
    if (configurations && xAxisTicks && xAxisTicks.length > 0 && yAxisTicks && yAxisTicks.length > 0) {
        var YAxisMin = Math.max.apply(Math, yAxisTicks);
        var YAxisMax = Math.min.apply(Math, yAxisTicks);
        var XAxisMin = Math.max.apply(Math, xAxisTicks);
        var XAxisMax = Math.min.apply(Math, xAxisTicks);
        for (var _i = 0, _a = configurations.reverse(); _i < _a.length; _i++) {
            var configuration = _a[_i];
            var ascendingDiagonalReferenceLine = configuration.ascendingDiagonalReferenceLine, descendingDiagonalReferenceLine = configuration.descendingDiagonalReferenceLine;
            var syncXYTicks = configuration.syncXYTicks;
            if (syncXYTicks) {
                var combinedTicks = __spreadArrays(xAxisTicks, yAxisTicks);
                var combinedMin = Math.min.apply(Math, combinedTicks);
                var combinedMax = Math.max.apply(Math, combinedTicks);
                YAxisMin = XAxisMin = combinedMin;
                YAxisMax = XAxisMax = combinedMax;
            }
            if (ascendingDiagonalReferenceLine) {
                returnElements.push({
                    type: 'ReferenceLine',
                    props: __assign({ segment: [
                            { x: XAxisMin, y: YAxisMin },
                            { x: XAxisMax, y: YAxisMax },
                        ] }, ascendingDiagonalReferenceLine),
                });
            }
            if (descendingDiagonalReferenceLine) {
                returnElements.push({
                    type: 'ReferenceLine',
                    props: __assign({ segment: [
                            { x: XAxisMin, y: YAxisMax },
                            { x: XAxisMax, y: YAxisMin },
                        ] }, descendingDiagonalReferenceLine),
                });
            }
        }
    }
    return returnElements;
}
exports.getDynamicReferenceLines = getDynamicReferenceLines;
function getTicks(element, elements, composedChartProps) {
    if ((element.type === 'YAxis' || element.type === 'XAxis') && element.props) {
        var _a = element.props, tickPivotPoint = _a.tickPivotPoint, tickCount = _a.tickCount, tickFormatter = _a.tickFormatter, dataKey = _a.dataKey, centerTickPivotPoint = _a.centerTickPivotPoint, persistQuadrants = _a.persistQuadrants;
        var barElement = elements.find(function (element) { return element.type === 'Bar'; });
        var labelListProps = barElement && barElement.props && barElement.props.labelList;
        var usingTopBarLabels = labelListProps && labelListProps.position && labelListProps.position === 'top';
        var ticks = [];
        var precision = getTickPrecision(tickFormatter);
        if (typeof tickPivotPoint === 'number') {
            var tickHandler = new TickHandler_1.TickHandler({ precision: precision, usingTopBarLabels: usingTopBarLabels, count: tickCount, elementProps: element.props });
            ticks = tickHandler.getTicksForSeries(composedChartProps.data, getSeriesKeysFromChartElements(elements, (dataKey && dataKey.toString()) || undefined), tickPivotPoint, undefined, centerTickPivotPoint, persistQuadrants);
            return ticks;
        }
    }
}
function getTickPrecision(tickFormatter) {
    if (tickFormatter && typeof tickFormatter !== 'function' && tickFormatter.options) {
        var _a = tickFormatter.options, maximumFractionDigits = _a.maximumFractionDigits, minimumFractionDigits = _a.minimumFractionDigits;
        return maximumFractionDigits || minimumFractionDigits;
    }
}
function applyTickPivotPoint(element, elements, composedChartProps) {
    if ((element.type === 'YAxis' || element.type === 'XAxis') && element.props) {
        element.props.ticks = getTicks(element, elements, composedChartProps);
        // Need to have at least 3 ticks when explicitly setting the tickCount on an axis otherwise
        // recharts throws a max callstack error
        if (element && element.props && element.props.ticks && element.props.ticks.length > 2) {
            element.props.tickCount = element.props.ticks.length;
        }
    }
}
exports.applyTickPivotPoint = applyTickPivotPoint;
function applyCustomTickLabel(element, translationContext) {
    if ((element.type === 'YAxis' || element.type === 'XAxis') && element.props) {
        var _a = element.props, customTickLabel_1 = _a.customTickLabel, tickFormatter_1 = _a.tickFormatter;
        if (customTickLabel_1) {
            element.props.tick = function (props) {
                var dy = customTickLabel_1.dy, dx = customTickLabel_1.dx, rotation = customTickLabel_1.rotation, textAnchor = customTickLabel_1.textAnchor, fill = customTickLabel_1.fill, width = customTickLabel_1.width;
                var x = props.x, y = props.y, payload = props.payload;
                var textProps = {
                    dy: dy,
                    dx: dx,
                    fill: fill,
                    width: width,
                    textAnchor: textAnchor,
                    angle: rotation,
                    x: 0,
                    y: 0,
                };
                var value = payload.value;
                if (tickFormatter_1 && typeof tickFormatter_1 === 'function') {
                    value = tickFormatter_1(value);
                }
                return (React.createElement("g", { transform: "translate(" + x + "," + y + ")" },
                    React.createElement(recharts_1.Text, __assign({}, textProps), value)));
            };
        }
    }
}
exports.applyCustomTickLabel = applyCustomTickLabel;
function applySeriesLabels(element, translationContext) {
    if ((element.type === 'Bar') && element.props) {
        var labelList = element.props.labelList;
        if (labelList && (labelList.position === 'outside' || labelList.position === 'end')) {
            element.props.label = customisedLabel;
            element.props.label.formatter = labelList.formatter;
            element.props.labelList = undefined;
        }
    }
    if ((element.type === 'Line') && element.props) {
        var lastLabel = element.props.lastLabel;
        if (lastLabel && lastLabel.enabled) {
            element.props.label = React.createElement(LastSeriesLabel_1.default, { translationContext: translationContext, overrides: lastLabel, seriesProps: element.props });
        }
    }
}
exports.applySeriesLabels = applySeriesLabels;
function applyDataLength(element, dataLength) {
    if ((element.type === 'Line') && element.props) {
        if (dataLength) {
            element.props.length = dataLength;
        }
    }
}
exports.applyDataLength = applyDataLength;
function applyCustomTickValues(element, props) {
    if ((element.type === 'YAxis' || element.type === 'XAxis') && element.props && props) {
        var selectedChartPeriod = props.selectedChartPeriod, composedChartProps = props.composedChartProps, dateOptions = props.dateOptions;
        var tickOptions = getTickOptions(element.type, dateOptions);
        if (tickOptions) {
            var tickCount = getAxisTickCount(tickOptions, selectedChartPeriod);
            var syncTickOptions = getSyncTickOptionsForAxisType(element.type, dateOptions);
            var datasetCount = composedChartProps && composedChartProps.data && composedChartProps.data.length;
            if (datasetCount) {
                // Don't adjust the data set count if the syncTickOptions is configured,
                // it throws the calculations out and will not generate a tick per data point
                var datasetLength = syncTickOptions ? datasetCount : datasetCount - 1;
                tickCount = Math.min(tickCount, datasetLength);
            }
            if (tickCount > 0) {
                var data = composedChartProps && composedChartProps.data || [];
                var _a = element.props, _b = _a.dataKey, dataKey = _b === void 0 ? 'date' : _b, _c = _a.domain, domain = _c === void 0 ? ['dataMin', 'dataMax'] : _c;
                var domainValues = getDomainValues(domain, dataKey, data);
                element.props.ticks = getCustomTicks(domainValues, tickCount, dataKey, data, syncTickOptions);
                // Ensure that the axis interval configuration is removed, else Recharts will override the synced ticks
                if (element.type === 'XAxis' && syncTickOptions && element.props) {
                    delete element.props.interval;
                }
            }
        }
    }
}
exports.applyCustomTickValues = applyCustomTickValues;
function getSyncTickOptionsForAxisType(axisType, dateOptions) {
    if (dateOptions) {
        if (axisType === 'XAxis') {
            return dateOptions.xAxisTickOptions && dateOptions.xAxisTickOptions.syncTickOptions;
        }
        if (axisType === 'YAxis') {
            return dateOptions.yAxisTickOptions && dateOptions.yAxisTickOptions.syncTickOptions;
        }
    }
}
function applyAnimationLogic(element, props) {
    switch (element.type) {
        case 'Area':
        case 'Bar':
        case 'Line':
        case 'Scatter':
        // Put this in when updating the latest version of recharts
        // case 'Funnel':
        case 'Pie':
        case 'Radar':
        case 'RadialBar':
        case 'Treemap':
        // Put this in when updating the latest version of recharts
        // case 'FunnelChart':
        case 'Tooltip':
            var globalAnimation = global[exports.KSYS_CHART_ANIMATION_KEY];
            var elementPropsAnimation = element.props && element.props.isAnimationActive;
            var propsAnimation = props['isAnimationActive'];
            var isAnimationActive = true;
            if (typeof elementPropsAnimation === 'boolean') {
                isAnimationActive = elementPropsAnimation;
            }
            else if (typeof propsAnimation === 'boolean') {
                isAnimationActive = propsAnimation;
            }
            else if (typeof globalAnimation === 'boolean') {
                isAnimationActive = globalAnimation;
            }
            if (element.props) {
                element.props.isAnimationActive = isAnimationActive;
            }
            break;
        default:
            break;
    }
}
exports.applyAnimationLogic = applyAnimationLogic;
function validateLegendElement(element, data) {
    if (data === void 0) { data = []; }
    if (element.type === 'Line' || element.type === 'Area') {
        var props = element.props;
        if (props && props.legendType) {
            var dataKey_1 = props.dataKey;
            var validData = data.find(function (d) { return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(d[dataKey_1.toString()]); });
            if (!validData) {
                props.legendType = 'none';
            }
        }
    }
}
exports.validateLegendElement = validateLegendElement;
function getTickOptions(elementType, dateOptions) {
    if (dateOptions) {
        if (elementType === 'XAxis' && dateOptions.xAxisDateAsNumber) {
            return dateOptions.xAxisTickOptions;
        }
        if (elementType === 'YAxis' && dateOptions.yAxisDateAsNumber) {
            return dateOptions.yAxisTickOptions;
        }
    }
}
exports.getTickOptions = getTickOptions;
function getAxisTickCount(tickOptions, selectedPeriod) {
    var _a = tickOptions.tickCount, defaultTickCount = _a === void 0 ? 0 : _a, _b = tickOptions.periodOptions, periodOptions = _b === void 0 ? [] : _b;
    var periodTickCount = periodOptions.filter(function (option) { return option.periodKey === selectedPeriod; });
    if (!isNullOrEmpty(periodTickCount)) {
        return periodTickCount[0].tickCount || defaultTickCount;
    }
    return defaultTickCount;
}
exports.getAxisTickCount = getAxisTickCount;
function getDomainValues(domain, dataKey, data) {
    var start = domain[0], end = domain[1];
    if (start === 'dataMin') {
        start = getValueWithDataKey(data[0], dataKey);
    }
    if (end === 'dataMax') {
        end = getValueWithDataKey(data[data.length - 1], dataKey);
    }
    return { start: start, end: end };
}
exports.getDomainValues = getDomainValues;
function getValueWithDataKey(dataObject, dataKey) {
    if (typeof dataKey === 'string' || typeof (dataKey) === 'number') {
        return dataObject[dataKey];
    }
    return dataKey(dataObject);
}
exports.getValueWithDataKey = getValueWithDataKey;
function getCustomTicks(domainValues, tickCount, dataKey, data, syncTickOptions) {
    if (dataKey === void 0) { dataKey = 'date'; }
    var start = domainValues.start, end = domainValues.end;
    var interval = (end - start) / tickCount;
    var dataPoints = data
        .map(function (item) { return getValueWithDataKey(item, dataKey); })
        .filter(function (item) { return item >= start && item <= end; });
    if (syncTickOptions) {
        var tickHandler = new TickHandler_1.TickHandler({ syncTickOptions: syncTickOptions });
        var syncedTicks = tickHandler.getSyncedTicksFromData(dataPoints, tickCount);
        return syncedTicks;
    }
    var ticks = [start];
    for (var i = 1; i <= tickCount - 1; i++) {
        var target = start + (interval * i);
        ticks.push(getClosestValue(target, dataPoints));
    }
    ticks.push(end);
    return ticks;
}
exports.getCustomTicks = getCustomTicks;
function getClosestValue(target, values) {
    if (!isNullOrEmpty(values)) {
        var under = Math.max.apply(Math, values.filter(function (value) { return value <= target; }));
        var over = Math.min.apply(Math, values.filter(function (value) { return value >= target; }));
        if ((target - under) < (over - target)) {
            return under;
        }
        return over;
    }
    return target;
}
exports.getClosestValue = getClosestValue;
var customisedLabel = function (passedProps) {
    var content = passedProps.content, value = passedProps.value;
    var labelFormatter = content && content.formatter;
    var xNew;
    var textAnchor;
    var fontHeight = 7;
    // messy formula to work out the central positon of the label relative to the bar height
    var yPosition = passedProps.y + passedProps.height - 1 - ((passedProps.height - fontHeight) / 2);
    if (passedProps.value < 0) {
        xNew = -2;
        textAnchor = 'end';
    }
    else {
        xNew = +2;
        textAnchor = 'starts';
    }
    return React.createElement(CustomSeriesLabel_1.default, { x: passedProps.x, y: yPosition, width: passedProps.width || 0, dx: (passedProps.width || 0) + xNew, fill: '#000000', textAnchor: textAnchor }, labelFormatter ? formatter(labelFormatter, value) : value);
};
function applyTranslationsToComposedChartProps(composedChartProps, translationContext) {
    if (composedChartProps) {
        var data = composedChartProps.data;
        applyTranslationsToDataName(translationContext, data);
    }
}
exports.applyTranslationsToComposedChartProps = applyTranslationsToComposedChartProps;
function applyTranslationsToDataName(translationContext, data) {
    if (data) {
        for (var _i = 0, _a = data; _i < _a.length; _i++) {
            var row = _a[_i];
            row['name'] = translationContext.translate(row.name);
        }
    }
}
exports.applyTranslationsToDataName = applyTranslationsToDataName;
function applyRebaseToComposedChartProps(composedChartProps, options) {
    if (composedChartProps && !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(composedChartProps.data) && options) {
        var data = composedChartProps.data;
        composedChartProps.data = rebase(data, options);
    }
}
exports.applyRebaseToComposedChartProps = applyRebaseToComposedChartProps;
function translateTickValues(translationContext) {
    return function (tick) {
        if (typeof tick === 'string') {
            return translationContext.translate(tick);
        }
        return tick;
    };
}
exports.translateTickValues = translateTickValues;
function applyTranslations(element, translationContext) {
    // Convert the tickFormatter from IFormatter to a function
    if (element.type === 'XAxis' ||
        element.type === 'YAxis') {
        if (element.props) {
            var label = element.props.label;
            if (label) {
                if (typeof label === 'object' && label.value) {
                    label.value = translationContext.translate(label.value.toString());
                }
                if (typeof label === 'string') {
                    element.props.label = translationContext.translate(label);
                }
            }
            // Translate the axis ticks
            // element.props = { ...element.props };
            if (!element.props.tickFormatter) {
                element.props.tickFormatter = translateTickValues(translationContext);
            }
        }
    }
    // Translate the chart element for static legend names
    if (element.type === 'Bar' ||
        element.type === 'Line' ||
        element.type === 'Area') {
        if (element.props) {
            var name_1 = element.props.name;
            if (name_1) {
                if (typeof name_1 === 'string') {
                    element.props.name = translationContext.translate(name_1);
                }
            }
        }
    }
    if (element.type === 'Pie') {
        if (element.props && element.props.data) {
            for (var _i = 0, _a = element.props.data; _i < _a.length; _i++) {
                var dataPoint = _a[_i];
                dataPoint.name = translationContext.translate(dataPoint.name);
            }
        }
    }
}
exports.applyTranslations = applyTranslations;
function getSeriesKeysFromChartElements(elements, scatterKey) {
    var response = [];
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];
        if (element.type === 'Area' ||
            element.type === 'Bar' ||
            element.type === 'Line') {
            if (element.props && element.props.dataKey) {
                response.push(element.props.dataKey.toString());
            }
        }
        else if (element.type === 'Scatter' && scatterKey) {
            response.push(scatterKey);
        }
    }
    return response;
}
exports.getSeriesKeysFromChartElements = getSeriesKeysFromChartElements;
function getSeriesKey(row, rowIndex) {
    return "series_" + rowIndex;
}
exports.getSeriesKey = getSeriesKey;
function getSeriesKeysFromRows(rows) {
    return rows.map(getSeriesKey);
}
exports.getSeriesKeysFromRows = getSeriesKeysFromRows;
function getValueColumns(columns) {
    if (columns === void 0) { columns = []; }
    var nameColumn = columns[0], valueColumns = columns.slice(1);
    return valueColumns;
}
exports.getValueColumns = getValueColumns;
function getNameColumn(columns) {
    if (columns === void 0) { columns = []; }
    var nameColumn = columns[0], valueColumns = columns.slice(1);
    return nameColumn;
}
exports.getNameColumn = getNameColumn;
function getChartDataFromTable(tableProps, globalConfiguration, translationHelper) {
    var _a = tableProps.rows, rows = _a === void 0 ? [] : _a;
    var tableLogic = new TableLogic_1.TableLogic(tableProps, globalConfiguration, translationHelper);
    var columns = tableLogic.visibleColumns;
    var valueColumns = getValueColumns(columns);
    var response = [];
    var _loop_3 = function (valueColumnIndex) {
        var valueColumn = valueColumns[valueColumnIndex];
        var header = valueColumn.header;
        if (valueColumnIndex > response.length - 1) {
            response.push({
                name: header || 'No Name',
            });
        }
        var responseRow = response[valueColumnIndex];
        rows.forEach(function (row, rowIndex) {
            var key = getSeriesKey(row, rowIndex);
            responseRow[key] = tableLogic.getRawValue(row, valueColumn);
        });
    };
    for (var valueColumnIndex = 0; valueColumnIndex < valueColumns.length; valueColumnIndex++) {
        _loop_3(valueColumnIndex);
    }
    return response;
}
exports.getChartDataFromTable = getChartDataFromTable;
function rebase(data, options) {
    if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(data) && options) {
        var rebaser = new ksys_app_template_1.helpers.RebaseHelper(options);
        return rebaser.rebase(data);
    }
    return data;
}
exports.rebase = rebase;
function getNumber(property) {
    if (typeof property === 'number') {
        return property;
    }
    if (typeof property === 'string') {
        return parseInt(property, 10);
    }
    return;
}
exports.getNumber = getNumber;
function calculateBarChartHeight(composedChartProps, elements) {
    if (composedChartProps === void 0) { composedChartProps = {}; }
    if (elements === void 0) { elements = []; }
    if (composedChartProps.layout !== 'vertical') {
        return;
    }
    var barElements = elements.filter(function (element) { return element.type === 'Bar'; });
    if (barElements.length > 0) {
        var barElement = barElements[0];
        if (barElement && barElement.props) {
            // workout bar size
            var maxBarSize = getNumber(composedChartProps.maxBarSize);
            var barSize = getNumber(barElement.props.barSize || composedChartProps.barSize);
            if (maxBarSize && (!barSize || barSize > maxBarSize)) {
                barSize = maxBarSize;
            }
            // calculate chart height based on bar chart sizes
            var data = composedChartProps.data;
            if (barSize && Array.isArray(data) && data.length > 0) {
                var dataCount = data.length;
                var seriesCount = barElements.length;
                var barGap = getNumber(composedChartProps.barGap) || 0;
                /**
                 * Calculating category gap
                 * It appears recharts default to 10 when the specified values is 1 or lower.
                 */
                var barCategoryGapRaw = getNumber(composedChartProps.barCategoryGap);
                var barCategoryGap = barCategoryGapRaw && barCategoryGapRaw > 1 ? barCategoryGapRaw : 10;
                var categoryGaps = (dataCount * barCategoryGap) + barCategoryGap; // we add the additional gap for the gap that precedes the first bar.
                // Each bar in the category contributes to the height
                var barSizes = dataCount * seriesCount * barSize;
                // Each gap between the bars in a category contributes to the chart height
                var barGaps = dataCount * (seriesCount - 1) * barGap;
                // The xAxis height affects the chart height
                var xAxisHeight = 0;
                var xAxisElement = elements.find(function (element) { return element.type === 'XAxis'; });
                if (xAxisElement && xAxisElement.props) {
                    xAxisHeight = xAxisElement.props.height || 30;
                }
                // The legend height affects the chart height
                var legendHeight = 0;
                var legendElement = elements.find(function (element) { return element.type === 'Legend'; });
                if (legendElement && legendElement.props) {
                    legendHeight = legendElement.props.height || 40;
                }
                return barSizes + barGaps + categoryGaps + xAxisHeight + legendHeight;
            }
        }
    }
    return;
}
exports.calculateBarChartHeight = calculateBarChartHeight;
function useAxisDateAsNumber(axis, data) {
    var response = [];
    if (data) {
        if (axis.dataKey) {
            axis.type = 'number';
            for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                var element = data_2[_i];
                var clone = Object.assign({}, element);
                var value = clone[axis.dataKey];
                value = new Date(value).getTime();
                clone[axis.dataKey] = value;
                response.push(clone);
            }
        }
        else {
            response.push.apply(response, data);
        }
    }
    return response;
}
exports.useAxisDateAsNumber = useAxisDateAsNumber;
/**
 * Sets up the global disclaimers for the line and bars and returns a boolean to indicate if disclaimers are being used
 * @returns boolean
 */
function applyGlobalDisclaimers(elements, data, queryStore, appKey) {
    var _a;
    if (data === void 0) { data = []; }
    var hasSuperscriptDisclaimer = false;
    ksys_app_template_1.utils.globalDisclaimers.initializeGlobalDisclaimers();
    var globalDisclaimerStore = ksys_app_template_1.utils.globalDisclaimers.getGlobalDisclaimerStore();
    if (globalDisclaimerStore) {
        for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
            var element = elements_2[_i];
            // currently only supporting bars and lines
            if ((element.type === 'Bar' || element.type === 'Line')) {
                if (element && element.props && element.props.disclaimers !== undefined &&
                    queryStore &&
                    appKey) {
                    hasSuperscriptDisclaimer = true;
                    // Use any type to apply an internal _globalDisclaimers prop with the applicable disclaimers
                    if (!element.props._globalDisclaimers) {
                        element.props._globalDisclaimers = [];
                    }
                    for (var _b = 0, _c = element.props.disclaimers; _b < _c.length; _b++) {
                        var targettedDisclaimer = _c[_b];
                        var _d = targettedDisclaimer.disclaimers, disclaimersConfig = _d === void 0 ? [] : _d, conditional = targettedDisclaimer.conditional;
                        if (conditional) {
                            var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditional);
                            if (conditionalHelper.matchesWithOptions({ instance: data, executionOptions: { responseContext: data } })) {
                                // pushes the current element disclaimers onto the props so that we can get the relevant superscripts
                                (_a = element.props._globalDisclaimers).push.apply(_a, globalDisclaimerStore.add.apply(globalDisclaimerStore, __spreadArrays([appKey, data, queryStore], disclaimersConfig)));
                            }
                        }
                        else {
                            // pushes the current element disclaimers onto the props so that we can get the relevant superscripts
                            element.props._globalDisclaimers.push(globalDisclaimerStore.add.apply(globalDisclaimerStore, __spreadArrays([appKey, data, queryStore], disclaimersConfig)));
                        }
                    }
                }
            }
        }
    }
    return hasSuperscriptDisclaimer;
}
exports.applyGlobalDisclaimers = applyGlobalDisclaimers;
